unable to read source [project]/momira.app/web/node_modules/@grpc/proto-loader/src/index.ts